import { Navigate, Route, Routes } from 'react-router-dom';

import { LoginPage } from '../features/auth';
import { MyLeavesPage } from '../features/my-leaves';
import { SettingsPage } from '../features/settings';
import { TeamHomePage } from '../features/team';
import { ResponsiveLayout } from '../layouts';
import { RequireAuth } from './RequireAuth';

export const AppRoutes = () => {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />

      <Route element={<RequireAuth />}>
        <Route element={<ResponsiveLayout />}>
          <Route index element={<TeamHomePage />} />
          <Route path="my" element={<MyLeavesPage />} />
          <Route path="settings" element={<SettingsPage />} />
        </Route>
      </Route>

      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
};
